/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react'
import { arrayOf, shape, string } from 'prop-types'

import Field from '@groovehq/internal-design-system/lib/components/Field/Field'
import {
  text,
  button,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { isValidEmail } from 'util/strings'

import { useFieldArray } from 'react-hook-form'

import { styles } from './styles'
import RoleSelection from '../RoleSelection'

const AddUserRows = ({
  control,
  className,
  emailFields,
  moreBtnName,
  setSendMode,
}) => {
  const { fields, update } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: 'user', // unique name for your Field Array
    // keyName: "id", default to "id", you can change the key name
  })

  const handleModeChange = useCallback(() => setSendMode('bulk'), [setSendMode])

  // Handle select role
  const handleSelectRole = useCallback(
    (key, index) => {
      const current = fields[index]
      update(index, { ...current, role: key })
    },
    [fields, update]
  )

  const handleInputChange = useCallback(
    e => {
      const { value, name: index } = e.target
      const current = fields[index]
      update(index, { ...current, email: value, feedback: null })
    },
    [fields, update]
  )

  const validateEmail = useCallback(
    e => {
      const { value, name: index } = e.target
      const current = fields[index]
      let feedback = null
      if (value !== '' && !isValidEmail(value)) {
        feedback = {
          help: 'The email is invalid',
          validateStatus: 'error',
        }
      }
      update(index, { ...current, email: value, feedback })
    },
    [fields, update]
  )

  const renderList =
    fields &&
    fields.map((field, index) => (
      <div css={styles.row} key={field.id}>
        <Field
          placeholder="Enter email address..."
          htmlType="email"
          name={index}
          onChange={handleInputChange}
          onBlur={validateEmail}
          value={field.value}
          css={styles.field}
          {...field.feedback}
        />
        <RoleSelection
          onSelect={key => handleSelectRole(key, index)}
          role={field.role}
        />
      </div>
    ))

  return (
    <div className={className}>
      {emailFields.length > 0 && (
        <div css={[text.styles.fontMedium, styles.row]} className="grui mb-10">
          <span>Email</span>
          <span>Role</span>
        </div>
      )}

      {renderList}

      <div className="grui mt-7">
        <button
          type="button"
          css={button.styles.link}
          onClick={handleModeChange}
        >
          {`+ ${moreBtnName}`}
        </button>
      </div>
    </div>
  )
}

AddUserRows.propTypes = {
  className: string,
  emailFields: arrayOf(
    shape({
      name: string,
      value: string,
      role: string,
    })
  ),
  moreBtnName: string,
}

AddUserRows.defaultProps = {
  className: undefined,
  emailFields: [],
  onEmailFieldChange() {},
  moreBtnName: 'Bulk invite team',
  onShowBulkUsers() {},
}

export default AddUserRows
